import React from 'react';
import PropTypes from 'prop-types';
import { Row, Alert } from 'react-bootstrap';
import DisclosureSummary from '../disclosure/DisclosureSummary';
import { Link } from 'react-router-dom';
import { prices } from 'prices';
import { LayoutImage } from '../LayoutApproval';

const ConfirmedColor = ({ roomInfo, imgColor, imgColorSlab, job }) => {
  const templated = job?.template?.status === 'Templated';

  const faCompleteNoInstall = job?.faRelease && !job?.install;

  return (
    roomInfo?.brand &&
    roomInfo?.color && (
      <>
        {!faCompleteNoInstall && <hr />}
        <h5>Material</h5>
        <p>
          Color:{' '}
          <strong>
            {roomInfo?.brand} {roomInfo?.color}
          </strong>{' '}
        </p>
        {imgColor && (
          <>
            <Row className="flex-center pt-1">Close-up</Row>
            <Row className="flex-center pt-1 pb-2">
              <img
                // style={{ width: '400px' }}
                alt={`${roomInfo?.brand} ${roomInfo?.color}`}
                src={imgColor?.src}
              />
            </Row>
          </>
        )}
        {imgColorSlab && (
          <>
            <Row className="flex-center pt-2 breakBefore">Full Slab</Row>
            <Row className="flex-center pt-1 pb-2">
              <img
                // style={{ width: '400px' }}
                alt={`${roomInfo?.brand} ${roomInfo?.color} Slab`}
                src={imgColorSlab?.src}
              />
            </Row>
          </>
        )}
        {(imgColor || imgColorSlab) && (
          <Row>
            <p
              className="fs--1"
              style={{ fontStyle: 'italic', textAlign: 'center' }}
            >
              Pictures are representative ...
              <br />
              your specific slab(s) will vary
            </p>
          </Row>
        )}
        <DisclosureSummary job={job} />
        <p className="mb-1">
          <strong>Digital Rendering</strong>
        </p>
        {job?.faRelease ? (
          <>
            {job?.rendering?.decision === 'yes' && (
              <>
                {!job?.digitalLayout && (
                  <p>
                    You purchased a{' '}
                    <Link to={'/rendering'}>Digital Rendering</Link>. A digital
                    image of your layout will be created and sent to you for
                    approval when it is complete.
                  </p>
                )}

                {job?.digitalLayout && job.digitalLayout.approved && (
                  <>
                    <p>
                      Here is your approved digital layout (
                      <em>
                        please check your email for a record of your approval
                      </em>
                      ):
                    </p>
                    <LayoutImage />
                  </>
                )}
                {job?.digitalLayout && !job.digitalLayout.approved && (
                  <Alert variant="secondary">
                    We will contact you to discuss your digital layout.
                  </Alert>
                )}
              </>
            )}
            {job?.rendering?.decision === 'no' && (
              <>
                <p>
                  You chose not to purchase{' '}
                  <Link to={'/rendering'}>digital rendering</Link>.
                </p>
              </>
            )}
          </>
        ) : (
          <>
            {job?.rendering?.decision === 'yes' && (
              <p>
                You added <Link to={'/rendering'}>Digital Rendering</Link>
                {!templated && <> ({prices.digitalRendering})</>}
              </p>
            )}
            {job?.rendering?.decision === 'no' && (
              <>
                <p>
                  You declined <Link to={'/rendering'}>digital rendering</Link>
                  {!templated && <> ({prices.digitalRendering})</>}
                </p>
              </>
            )}
            {job?.rendering?.decision === 'notsure' && !templated && (
              <p>
                We will discuss <Link to={'/rendering'}>digital rendering</Link>{' '}
                ({prices.digitalRendering}) with you when your technician comes
                to measure.
              </p>
            )}
          </>
        )}
      </>
    )
  );
};

ConfirmedColor.propTypes = {
  roomInfo: PropTypes.object,
  imgColor: PropTypes.object,
  imgColorSlab: PropTypes.object,
  job: PropTypes.object
};

export default ConfirmedColor;
